import { PaginationFooter } from 'ui/paginationFooter';
import { FullWidth } from 'ui/utility/fullWidth';
import { usePaginationContext } from 'utils/contexts/pagination';

export const TablePagination = ({ numItems }: { numItems: number }) => {
  const {
    currentPage,
    pageSize: itemsPerPage,
    setCurrentPage,
    setPageSize,
  } = usePaginationContext();

  return (
    <FullWidth>
      <PaginationFooter
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        onUpdate={({ pageSize, page }) => {
          setCurrentPage(page);
          setPageSize(pageSize);
        }}
      />
    </FullWidth>
  );
};
